import { Sccs1ConnectionInfoChangedRealTimeData } from '../../../../generated/signalR/sccs1-connection-info-changed-real-time-data';

export class Sccs1ConnectionInfoUpdated {
   public static readonly type = '[Sccs1Connection] connections info updated';

   constructor(public connectionChangedRealTimeData: Sccs1ConnectionInfoChangedRealTimeData) {}
}

export class Sccs1ConnectionChanged {
   public static readonly type = '[Sccs1Connection] connections changed';

   constructor(public newConnection: string) {}
}

export class Sccs1ConnectionChangedShowInfo {
   public static readonly type = '[Sccs1Connection] connections changed show info';

   constructor() {}
}
